import { getDetails } from '@/api/admin/user'
import { isValidResponse } from '@/util/responseUtil'

var validateUsername = (rule, value, callback) => {
  getDetails(value).then(response => {
    if (window.boxType === 'edit') callback()
    let result = response.data.data
    if (isValidResponse(result)) {
      callback(new Error('用户名已经存在'))
    } else {
      callback()
    }
  })
}
export const tableOption = {
  border: true,
  index: false,
  stripe: true,
  menuAlign: 'center',
  editBtn: false,
  delBtn: false,
  refreshBtn: false,
  align: 'center',
  addBtn: false,
  column: [{
    fixed: true,
    label: 'id',
    prop: 'userId',
    span: 24,
    hide: true,
    editDisabled: true,
    addVisdiplay: false
  }, {
    fixed: true,
    label: '员工号',
    prop: 'username',
    editDisabled: true,
    solt: true,
    span: 24,
    rules: [{
      required: true,
      message: '请输入员工号',
      trigger: 'blur'
    },
    {
      min: 3,
      max: 20,
      message: '长度在 3 到 20 个字符',
      trigger: 'blur'
    },
    { validator: validateUsername, trigger: 'blur' }
    ]
  },
  {
    label: '密码',
    prop: 'password',
    formsolt: true,
    solt: true,
    value: '',
    hide: true,
    span: 24,
    rules: [{
      required: true,
      message: '密码不能为空且不少于6位',
      trigger: 'blur'
    },{
      min: 6,
      message: '密码不能为空且不少于6位',
      trigger: 'blur'
    }]
  },
  {
    fixed: true,
    label: 'Full Name',
    prop: 'nickname',
    solt: true,
    span: 24,
    rules: [{
      required: true,
      message: '请输入Full Name',
      trigger: 'blur'
    },
    {
      min: 3,
      max: 50,
      message: '长度在 3 到 50 个字符',
      trigger: 'blur'
    }]
  }, {
    label: '角色',
    prop: 'role',
    formsolt: true,
    solt: true,
    overHidden: true,
    span: 24,
    rules: [{
      required: true,
      message: '请选择角色',
      trigger: 'blur'
    }]
  }, {
    label: '官方号',
    prop: 'member',
    formsolt: true,
    solt: true,
    span: 24,
    rules: [{
      required: false,
      message: '请选择关联账号',
      trigger: 'blur'
    }]
  }, {
    label: '状态',
    prop: 'lockFlag',
    type: 'select',
    solt: true,
    span: 24,
    rules: [{
      required: true,
      message: '请选择状态',
      trigger: 'blur'
    }],
    dicData: [{
      label: '有效',
      value: '0'
    }, {
      label: '锁定',
      value: '9'
    }]
  }, {
    width: 120,
    label: '创建时间',
    prop: 'createTime',
    type: 'datetime',
    format: 'yyyy-MM-dd',
    editDisabled: true,
    addVisdiplay: false,
    span: 24
  }]
}
